export default "__VITE_ASSET__0dfda3bb__"